import Phaser from "phaser";

/** Art is baked at 2x and displayed at 0.5 scale, so rotated sprites and camera zoom stay
 * crisp (a cheap form of supersampling). */
export const ART_RES = 2;

/**
 * Paints a texture once with the Canvas 2D API (gradients, clipping, soft shapes — things
 * Phaser's Graphics can't do) and registers it under `key`. Drawing code works in display
 * pixels; the context is pre-scaled by `res`. No-op if the texture already exists.
 */
export function bakeTexture(
  scene: Phaser.Scene,
  key: string,
  width: number,
  height: number,
  draw: (ctx: CanvasRenderingContext2D) => void,
  res = ART_RES,
): string {
  if (scene.textures.exists(key)) return key;
  const texture = scene.textures.createCanvas(key, Math.ceil(width * res), Math.ceil(height * res));
  if (!texture) return key;
  const ctx = texture.getContext();
  ctx.save();
  ctx.scale(res, res);
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  draw(ctx);
  ctx.restore();
  texture.refresh();
  return key;
}

export const OUTLINE = 0x1a1a1a;

export function roundedRectPath(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
): void {
  const rr = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.arcTo(x + w, y, x + w, y + h, rr);
  ctx.arcTo(x + w, y + h, x, y + h, rr);
  ctx.arcTo(x, y + h, x, y, rr);
  ctx.arcTo(x, y, x + w, y, rr);
  ctx.closePath();
}
